import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Shower-with-corner-drain",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Shower with corner drain",
    description: "Shower-with-corner-drain",
    image: require("./Shower-with-corner-drain.svg"),
    svgIcon: require("./Shower-with-corner-drain.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M50.58,1.9H90.7c4,0,6.69,2.34,7.2,6.38A20.27,20.27,0,0,1,98,10.62q0,38.84,0,77.69a10.4,10.4,0,0,1-1.51,5.93,5.75,5.75,0,0,1-5.11,2.82H76.73c-22.12,0-44.24-.07-66.35,0-4.69,0-6.73-3.26-7.26-6.5A13.78,13.78,0,0,1,3,88.48q0-39,0-78A9.76,9.76,0,0,1,5.06,3.93a5.63,5.63,0,0,1,4.58-2c6.4,0,12.8,0,19.19,0H50.58Zm-4,8.38c-1.62,0-3.18,0-4.73,0a2.22,2.22,0,0,0-1.24.5A5.52,5.52,0,0,1,37,12.16c-5.71,0-11.43.07-17.15-.05A6.4,6.4,0,0,1,16.58,11a3.94,3.94,0,0,0-5.5,1,7.13,7.13,0,0,0-.9,4q0,33.12,0,66.25a13.49,13.49,0,0,0,.06,1.42C10.55,86.68,12,88,15,88H61.15q12.66,0,25.31,0a3.72,3.72,0,0,0,4-3,9.19,9.19,0,0,0,.32-2.51q0-33.37,0-66.76A10,10,0,0,0,90.71,14c-.37-2-1.57-3.77-4.3-3.75-8.85.07-17.7,0-26.54,0-.36,0-.72,0-1.17.07v3.39H57.65V10.28H53.17c-.64,0-.59.42-.59.84,0,3.81,0,7.62,0,11.43a1.29,1.29,0,0,0,.45.91c5.22,3.56,5.94,12.32,1.54,17a6.72,6.72,0,0,1-10.26,0,11,11,0,0,1-2.83-7.66c0-3.9,1.3-7.18,4.62-9.48a1.57,1.57,0,0,0,.46-1.11c0-3.65,0-7.29,0-10.93C46.59,11,46.55,10.7,46.53,10.28Zm12.22-2H60c8.88,0,17.76,0,26.64,0a5,5,0,0,1,4.49,2.48,8.35,8.35,0,0,1,1.23,4.76q0,33.64,0,67.28a12.42,12.42,0,0,1-.13,1.83C91.71,88.19,89.61,90,86,90H15l-1.33,0a4.11,4.11,0,0,1-3-1.45,8.08,8.08,0,0,1-2-5.72q0-33.64,0-67.28a11.93,11.93,0,0,1,.2-2.23c.49-2.65,2.67-5.39,5.6-5a.25.25,0,0,0,.17-.06V4.59c-2,0-3.81,0-5.64,0A3.62,3.62,0,0,0,6.05,6.43a7.56,7.56,0,0,0-1,4.41V88c0,.58,0,1.16.09,1.73.26,3.09,2,4.65,5,4.65H90.65a3.15,3.15,0,0,0,1,0,8.73,8.73,0,0,0,2.62-1.15c1.57-1.28,1.65-3.19,1.65-5q0-38.75,0-77.48a13.71,13.71,0,0,0-.11-1.93A4.56,4.56,0,0,0,91.1,4.53c-10.38.07-20.76,0-31.14,0-.39,0-.78,0-1.21.07ZM42.53,33a9.76,9.76,0,0,0,1.78,5.62c2.49,3.62,6.75,4,9.73.75,3.42-3.7,3.12-10.6-.6-14a5.85,5.85,0,0,0-8.25.33A10.06,10.06,0,0,0,42.53,33ZM16.77,4.66c0,.76,0,1.43,0,2.11a2.43,2.43,0,0,0,2,2.54,6.42,6.42,0,0,0,1.52.14q8.12,0,16.22,0a5.82,5.82,0,0,0,1.51-.15,2.38,2.38,0,0,0,2-2.06,22.08,22.08,0,0,0,0-2.58ZM51.45,22.55V4.06H47.72V22.55ZM42.2,8.23h2.33l.13-1.36,1.93-.11a15.4,15.4,0,0,0,0-1.68c0-.19-.3-.49-.46-.49-1.28,0-2.56,0-3.91,0ZM52.67,4.62V6.74h4.94V4.55h-4C53.3,4.56,53,4.6,52.67,4.62Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M46.53,10.28c0,.42.06.72.06,1,0,3.64,0,7.28,0,10.93a1.57,1.57,0,0,1-.46,1.11c-3.32,2.3-4.61,5.58-4.62,9.48a11,11,0,0,0,2.83,7.66,6.72,6.72,0,0,0,10.26,0c4.4-4.73,3.68-13.49-1.54-17a1.29,1.29,0,0,1-.45-.91c0-3.81,0-7.62,0-11.43,0-.42,0-.85.59-.84h4.48v3.46H58.7V10.35c.45,0,.81-.07,1.17-.07,8.84,0,17.69,0,26.54,0,2.73,0,3.93,1.75,4.3,3.75a10,10,0,0,1,.12,1.73q0,33.37,0,66.76A9.19,9.19,0,0,1,90.5,85a3.72,3.72,0,0,1-4,3q-12.64,0-25.31,0H15c-3,0-4.46-1.34-4.76-4.37a13.49,13.49,0,0,1-.06-1.42q0-33.12,0-66.25a7.13,7.13,0,0,1,.9-4,3.94,3.94,0,0,1,5.5-1,6.4,6.4,0,0,0,3.28,1.15c5.72.12,11.44.06,17.15.05a5.52,5.52,0,0,0,3.55-1.36,2.22,2.22,0,0,1,1.24-.5C43.35,10.24,44.91,10.28,46.53,10.28ZM72.27,75.09a9.34,9.34,0,0,0,1.67,5.55,5.58,5.58,0,0,0,9.24.64,10,10,0,0,0,.21-12.18c-2.58-3.1-6.24-3.2-9-.21A8.87,8.87,0,0,0,72.27,75.09Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M58.75,8.28V4.63c.43,0,.82-.07,1.21-.07,10.38,0,20.76,0,31.14,0a4.56,4.56,0,0,1,4.72,4.24,13.71,13.71,0,0,1,.11,1.93q0,38.75,0,77.48c0,1.86-.08,3.77-1.65,5a8.73,8.73,0,0,1-2.62,1.15,3.15,3.15,0,0,1-1,0H10.21c-3.08,0-4.78-1.56-5-4.65,0-.57-.09-1.15-.09-1.73V10.84a7.56,7.56,0,0,1,1-4.41A3.62,3.62,0,0,1,9,4.61c1.83-.07,3.67,0,5.64,0V8.2a.25.25,0,0,1-.17.06c-2.93-.36-5.11,2.38-5.6,5a11.93,11.93,0,0,0-.2,2.23q0,33.65,0,67.28a8.08,8.08,0,0,0,2,5.72,4.11,4.11,0,0,0,3,1.45L15,90H86c3.57,0,5.67-1.8,6.22-5.37a12.42,12.42,0,0,0,.13-1.83q0-33.65,0-67.28a8.35,8.35,0,0,0-1.23-4.76,5,5,0,0,0-4.49-2.48c-8.88,0-17.76,0-26.64,0Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M42.53,33a10.06,10.06,0,0,1,2.66-7.3,5.85,5.85,0,0,1,8.25-.33c3.72,3.4,4,10.3.6,14-3,3.21-7.24,2.87-9.73-.75A9.76,9.76,0,0,1,42.53,33Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M16.77,4.66H40.06a22.08,22.08,0,0,1,0,2.58,2.38,2.38,0,0,1-2,2.06,5.82,5.82,0,0,1-1.51.15q-8.12,0-16.22,0a6.42,6.42,0,0,1-1.52-.14,2.43,2.43,0,0,1-2-2.54C16.76,6.09,16.77,5.42,16.77,4.66Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M51.45,22.55H47.72V4.06h3.73Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M42.2,8.23V4.57c1.35,0,2.63,0,3.91,0,.16,0,.44.3.46.49a15.4,15.4,0,0,1,0,1.68l-1.93.11-.13,1.36Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M52.67,4.62c.33,0,.63-.06.93-.06h4V6.74H52.67Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              d="M72.27,75.09a8.87,8.87,0,0,1,2.16-6.2c2.72-3,6.38-2.89,9,.21a10,10,0,0,1-.21,12.18,5.58,5.58,0,0,1-9.24-.64A9.34,9.34,0,0,1,72.27,75.09Zm12,.21a8.26,8.26,0,0,0-2-5.59,4.66,4.66,0,0,0-7.08,0,8.54,8.54,0,0,0-1,9.34c2.1,3.9,6.49,4.08,8.9.38A7.88,7.88,0,0,0,84.31,75.3Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M84.31,75.3a7.88,7.88,0,0,1-1.17,4.1c-2.41,3.7-6.8,3.52-8.9-.38a8.54,8.54,0,0,1,1-9.34,4.66,4.66,0,0,1,7.08,0A8.26,8.26,0,0,1,84.31,75.3Zm-1.75-.2a5.3,5.3,0,0,0-1.38-3.73,3.17,3.17,0,0,0-4.56-.19,5.58,5.58,0,0,0-.1,7.66,3.07,3.07,0,0,0,4.54,0A5.16,5.16,0,0,0,82.56,75.1Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              d="M82.56,75.1a5.16,5.16,0,0,1-1.5,3.77,3.07,3.07,0,0,1-4.54,0,5.58,5.58,0,0,1,.1-7.66,3.17,3.17,0,0,1,4.56.19A5.3,5.3,0,0,1,82.56,75.1Zm-1,0c0-1.91-1.25-3.48-2.75-3.46s-2.72,1.65-2.68,3.53c0,0,0,.06,0,.1.1,1.91,1.31,3.34,2.79,3.29S81.53,76.91,81.52,75.07Z"
              transform="translate(-2.97 -1.86)"
            />
            <path
              class="cls-1"
              d="M81.52,75.07c0,1.84-1.18,3.41-2.63,3.46s-2.69-1.38-2.79-3.29c0,0,0-.07,0-.1,0-1.88,1.2-3.51,2.68-3.53S81.52,73.16,81.52,75.07Z"
              transform="translate(-2.97 -1.86)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
